import RocketIFrame from '@components/RocketIFrame';
import CallingTabCompletedMessage from './CallingTabCompletedMessage';
import CallingTabControls from './CallingTabControls';
import { UseCallingTabParams, useCallingTab } from './useCallingTab';

export default function CallingTab(props: UseCallingTabParams) {
  const callingTab = useCallingTab(props);

  return (
    <>
      {callingTab.showCompleteMessage && <CallingTabCompletedMessage />}

      {!callingTab.showCompleteMessage && (
        <RocketIFrame rocketBaseURL={callingTab.theIFrameURL} />
      )}
      <CallingTabControls {...callingTab} />
    </>
  );
}
